/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_login_oidc_failed_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not complete Minecraft sign-in`)
};

const zh_hans1_login_oidc_failed_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法完成 Minecraft 登录`)
};

const zh_hant1_login_oidc_failed_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法完成 Minecraft 登入`)
};

const fr_login_oidc_failed_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de terminer la connexion Minecraft`)
};

const de_login_oidc_failed_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft-Anmeldung konnte nicht abgeschlossen werden`)
};

const ja_login_oidc_failed_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft サインインを完了できませんでした`)
};

const ko_login_oidc_failed_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft 로그인을 완료할 수 없습니다`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const login_oidc_failed_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_oidc_failed_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_oidc_failed_title", locale)
	if (locale === "en") return en_login_oidc_failed_title(inputs)
	if (locale === "zh-Hans") return zh_hans1_login_oidc_failed_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_login_oidc_failed_title(inputs)
	if (locale === "fr") return fr_login_oidc_failed_title(inputs)
	if (locale === "de") return de_login_oidc_failed_title(inputs)
	if (locale === "ja") return ja_login_oidc_failed_title(inputs)
	return ko_login_oidc_failed_title(inputs)
};